import { GiAlienBug } from "react-icons/gi";
import { projectPrimaryColor } from "../../generalConfigs";
import { Card } from "react-bootstrap";

export default function NotFound() {
  return <div className="az-content pd-t-20 pd-b-20">
    <Card className="rounded-button pd-20">
      <div className="centered-flex">
        <GiAlienBug size={100} color={projectPrimaryColor} />
      </div>
      <h1 className="tx-34 text-center">404</h1>
      <h2 className="text-center tx-light">A <del>nave</del> página que você está buscando não existe.</h2>
      <p className="text-center tx-light">
        Não temos evidências da página que você está buscando, dizem que não existe, você já viu?
      </p>
    </Card>
  </div>
}
